import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ComponentBase } from '../../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { FormGroup } from '@angular/forms';
import { DatePipe, DecimalPipe } from '@angular/common';
import { DatosPeriodoViewModel, PlazoPeriodoCamViewModel } from '../plazos.types';

@Component({
    selector: 'app-plazos-edit',
    templateUrl: './plazos-edit.component.html',
})
export class PlazosEditComponent extends ComponentBase implements OnChanges, OnInit {
    @Input() plazoPeriodo: PlazoPeriodoCamViewModel;
    @Input() datosPeriodo: DatosPeriodoViewModel;
    @Input() formGroup: FormGroup;
    @Input() fechaParcelaOblig: boolean;
    @Input() fechaConfeccionOblig: boolean;
    @Input() fechaInvernaderoOblig: boolean;
    @Input() fechaEmpDeshidratadoraOblig: boolean;
    @Output() changeHabilitarExportacion = new EventEmitter();

    isCollapsedCabecera = false;
    isCollapsedPresentacion = false;
    isCollapsedExportacion = false;
    isCollapsedOtrosDatos = false;

    minDate = new Date();

    constructor(
        public datepipe: DatePipe,
        public decimalPipe: DecimalPipe,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.plazoPeriodo?.currentValue) {
            this.plazoPeriodo = { ...changes.plazoPeriodo.currentValue };
            this.updateForm();
        }
    }

    /**
     * This functions sets the values in the plazoPeriodo (@Input) into the form.
     */
    private updateForm(): void {
        this.formGroup.setValue({
            Id: this.plazoPeriodo?.Id || 0,
            IdPeriodo: this.plazoPeriodo?.IdPeriodo || 0,
            FechaInicioPeriodo: this.plazoPeriodo?.FechaInicioPeriodo ? new Date(this.plazoPeriodo?.FechaInicioPeriodo) : null,
            FechaFinPeriodo: this.plazoPeriodo?.FechaFinPeriodo ? new Date(this.plazoPeriodo?.FechaFinPeriodo) : null,
            PresentarSolicitudesFueraPeriodo: this.plazoPeriodo?.PresentarSolicitudesFueraPeriodo || false,
            FechaInicioPresentacion: this.plazoPeriodo?.FechaInicioPresentacion ? new Date(this.plazoPeriodo?.FechaInicioPresentacion) : null,
            FechaFinPresentacion: this.plazoPeriodo?.FechaFinPresentacion ? new Date(this.plazoPeriodo?.FechaFinPresentacion) : null,
            FechaInicioExportacionParcela: this.plazoPeriodo?.FechaInicioExportacionParcela ? new Date(this.plazoPeriodo?.FechaInicioExportacionParcela) : null,
            FechaInicioExportacionConfeccion: this.plazoPeriodo?.FechaInicioExportacionConfeccion
                ? new Date(this.plazoPeriodo?.FechaInicioExportacionConfeccion)
                : null,
            FechaInicioExportacionInvernadero: this.plazoPeriodo?.FechaInicioExportacionInvernadero
                ? new Date(this.plazoPeriodo?.FechaInicioExportacionInvernadero)
                : null,
            FechaInicioExportacionEmpDeshidratadoras: this.plazoPeriodo?.FechaInicioExportacionEmpDeshidratadoras
                ? new Date(this.plazoPeriodo?.FechaInicioExportacionEmpDeshidratadoras)
                : null,
            Parcela: this.plazoPeriodo?.Parcela || false,
            Confeccion: this.plazoPeriodo?.Confeccion || false,
            Invernadero: this.plazoPeriodo?.Invernadero || false,
            EmpresaDeshidratadora: this.plazoPeriodo?.EmpresaDeshidratadora || false,
            PresentacionAutoParcela: this.plazoPeriodo?.PresentacionAutoParcela || false,
            PresentacionAutoAlmacenes: this.plazoPeriodo?.PresentacionAutoAlmacenes || false,
            PresentacionAutoInvernadero: this.plazoPeriodo?.PresentacionAutoInvernadero || false,
            PresentacionAutoEmpDeshidratadoras: this.plazoPeriodo?.PresentacionAutoEmpDeshidratadoras || false,
            ObligatoriaPrimeraInspeccion: this.plazoPeriodo?.ObligatoriaPrimeraInspeccion || false,
            HabilitadaExportacionAlmacenes: this.plazoPeriodo?.HabilitadaExportacionAlmacenes || false,
            HabilitadaExportacionEmpDeshidratadoras: this.plazoPeriodo?.HabilitadaExportacionEmpDeshidratadoras || false,
            HabilitadaExportacionInvernaderos: this.plazoPeriodo?.HabilitadaExportacionInvernaderos || false,
            HabilitadaExportacionParcelas: this.plazoPeriodo?.HabilitadaExportacionParcelas || false,
        });

        this.form = this.formGroup; // componentBase uses this.form
    }

    changeHabilitadaExportacion(): void {
        this.changeHabilitarExportacion.emit();
    }

    get title(): string {
        return this.plazoPeriodo ? 'Editar' : 'Nuevo'; // work mode: edition or creation
    }
}
